import {
  CREATE_CONFIGURATOR_LABEL,
  CREATE_CONFIGURATOR_SCENE_API,
  CREATE_LABEL_OPTIONS_API,
  DELETE_CONFIGURATOR_LABEL_API,
  DELETE_CONFIGURATOR_VIEW_API,
  DELETE_LABEL_OPTIONS_API,
  DUPLICATE_CONFIGURATOR_API,
  DUPLICATE_CONFIGURATOR_SCENE_API,
  GET_CONFIGURATOR_API,
  GET_CONFIGURATOR_BACKGROUND_LIST_API,
  GET_CONFIGURATOR_CAMERA_PRESETS_API,
  GET_CONFIGURATOR_LABELS,
  GET_CONFIGURATOR_LIGHTING_API,
  GET_CONFIGURATOR_SCENE_LIST_API,
  GET_CONFIGURATOR_VIEW_LIST_API,
  GET_LABEL_OPTIONS_API,
  REORDER_CONFIGURATOR_SCENE_API,
  UPDATE_CONFIGURATOR_BACKGROUND_API,
  UPDATE_CONFIGURATOR_CAMERA_PRESETS_API,
  UPDATE_CONFIGURATOR_LABELS_API,
  UPDATE_CONFIGURATOR_LABEL_API,
  UPDATE_CONFIGURATOR_SCENE_API,
  UPDATE_CONFIGURATOR_VIEW_API,
  UPDATE_LABEL_OPTIONS_API,
  UPDATE_LABEL_OPTION_API,
  SAVE_AS_TEMPLATE_CONFIGURATOR_API,
  DOWNLOAD_CONFIGURATOR_API,
  GET_CONFIGURATOR_THEMES,
  GET_ALL_ASPECT_RATIO,
  GET_ALL_TEMPLATES,
  DUPLICATE_TEMPLATES,
  GET_RENDER_STORE_LIST,
  REORDER_VIEWS,
  SCENE_OPTION_DUPLICATE_API,
  CHECK_FOR_UNICODE,
  GET_SCENE_LABEL_PUBLIC_API,
  GET_LABEL_OPTIONS_PUBLIC_API,
  GET_PROTOTYPE_PREVIEWS_API,
  UPLOAD_DEFAULT_TEXTURE_THUMBNAIL,
  GET_LABEL_OPTIONS_WITH_TIME,
  DELETE_PREVIEWS,
  GET_SCENE_PUBLIC_DATA,
  GET_SCENE_PRIVATE_DATA,
  DOWNLOAD_IMAGES,
  UPLOAD_IMAGES,
  TEXTURE_RE_RENDER,
  UPLOAD_IMAGES_CONFIGURATOR,
  GET_SHADOW_IMAGES_PUBLIC,
  GET_SHADOW_IMAGES,
  GET_SCENE_VIEWS_PROTOTYPE,
  CREATE_CONFIGURATOR_LABEL_V2,
  UPDATE_CONFIGURATOR_LABELS_API_V2,
  GET_CONFIGURATOR_LABELS_V2,
  UPDATE_CONFIGURATOR_LABEL_API_V2,
  UPLOAD_DEFAULT_TEXTURE_THUMBNAIL_V2,
  DELETE_CONFIGURATOR_LABEL_API_V2,
  GET_LABEL_OPTIONS_API_V2,
  UPDATE_LABEL_OPTION_API_V2,
  DELETE_LABEL_OPTIONS_API_V2,
  CREATE_LABEL_OPTIONS_API_V2,
  UPDATE_LABEL_OPTIONS_API_V2,
  SCENE_OPTION_DUPLICATE_API_V2,
  CREATE_CONFIGURATOR_SCENE_API_V2,
  DUPLICATE_CONFIGURATOR_SCENE_API_V2,
  REORDER_CONFIGURATOR_SCENE_API_V2,
  GET_CONFIGURATOR_SCENE_LIST_API_V2,
  UPDATE_CONFIGURATOR_SCENE_API_V2,
  DUPLICATE_CONFIGURATOR_API_V2,
  GET_CONFIGURATOR_API_V2,
  GET_CONFIGURATOR_VIEW_LIST_API_V2,
  UPDATE_CONFIGURATOR_VIEW_API_V2,
  DELETE_CONFIGURATOR_VIEW_API_V2,
  GET_CONFIGURATOR_LIGHTING_API_V2,
  GET_CONFIGURATOR_BACKGROUND_LIST_API_V2,
  UPDATE_CONFIGURATOR_BACKGROUND_API_V2,
  GET_LABEL_OPTIONS_WITH_TIME_V2,
  TEXTURE_RE_RENDER_V2,
  UPLOAD_IMAGES_CONFIGURATOR_V2,
  GET_SCENE_LABEL_PUBLIC_API_V2,
  GET_LABEL_OPTIONS_PUBLIC_API_V2,
  GET_SCENE_PUBLIC_DATA_V2,
  GET_SCENE_PRIVATE_DATA_V2,
  GET_PROTOTYPE_PREVIEWS_API_V2,
  GET_SHADOW_IMAGES_V2,
  GET_SHADOW_IMAGES_PUBLIC_V2,
  GET_SCENE_VIEWS_PROTOTYPE_V2,
  DOWNLOAD_IMAGES_V2,
  UPLOAD_IMAGES_V2,
  REORDER_VIEWS_V2,
  DELETE_PREVIEWS_V2,
  CONFIG_PUBLIC_LINK_V2,
  LIGHTING_CONTENT_LIST,
  UPLOAD_MULTIPLE_LIGHTROOM,
  GET_SCENE_VIEWS_PUBLIC_PROTOTYPE_V2,
  GET_SCENE_VIEWS_PUBLIC_PROTOTYPE,
  GET_DEFAULT_TEXTURES,
  GET_DEFAULT_TEXTURES_V2,
  GET_SELECTED_TEXTURES_V2,
  GET_SELECTED_TEXTURES,
  GET_SCENE_IDS_V2,
  SET_SCENE_TEXTURE_SEQUENCE,
  GET_ALL_SCENE_TOKEN,
  GET_ALL_SCENE_TOKEN_V2,
  DOWNLOAD_SHADOW_IMAGES_V2,
  DOWNLOAD_SHADOW_IMAGES,
  UPLOAD_SHADOW_IMAGES,
  UPLOAD_SHADOW_IMAGES_V2,
  CONFIG_PUBLIC_DATA_V3,
  GET_CONFIGURATOR_ALL_MERGE_V2,
  GET_CONFIGURATOR_ALL_MERGE,
  GET_CONFIGURATOR_SINGLE_MERGE_V2,
  GET_CONFIGURATOR_SINGLE_MERGE,
  RENDER_STORE_KEYS_UPDATE_V2,
  GET_PUBLIC_PRODUCT_DATA,
  UPDATE_TEXTURE_LINKING,
  GET_TEXTURE_LINKING,
  GET_TEXTURE_LINKING_PUBLIC,
} from '../config/constant/apiConstant';
import { createDeleteApiAction, createGetListAction, createUpdateApiAction } from './apiGenerator';
import { productConfiguratorsActions } from '../redux/slicers/productConfiguratorsSlicer';
import {
  configuratorActions,
  selectConfiguratorData,
  selectConfiguratorId,
  selectConfiguratorSortBy,
  selectSceneById,
  selectSelectedSceneId,
} from '../redux/slicers/configurator/configurator.slicer';
import { generateNewName, objectToFormData, waitRandom } from '../helpers/jsHelper';
import {
  configuratorLabelDetailsActions,
  selectLabelOptions,
  selectLabelOptionsError,
  selectLabelOptionsLoaded,
  selectSortedLabelOptions,
} from '../redux/slicers/configurator/configuratorLabelDetails.slicer';
import { getAppState } from '../redux/store';
import { DEFAULT_SORT_BY, OPTION_TYPE } from '../constants/productConfiguratorConstants';
import { paginatedColorSelector } from '../redux/slicers/admin/paginatedColorSlicer';
import { paginatedTexturesSelector } from '../redux/slicers/textures/paginatedTexturesSlicer';
import { paginatedMaterialsSelector } from '../redux/slicers/materials/paginatedMaterialSlicer';
import { isEmpty } from 'lodash';
import {
  configuratorCameraActions,
  selectCameraPreset,
} from '../redux/slicers/configurator/configuratorCamera.slicer';
import {
  configuratorSceneViewsActions,
  selectCurrentSceneViews,
  selectFailedToLoadViews,
  selectSceneView,
  selectSceneViewsLoaded,
  selectSelectedViewInScene,
} from '../redux/slicers/configurator/configuratorViews.slicer';
import {
  configuratorSceneLabelsActions,
  // selectLabelById,
  selectSceneLabels,
  selectSceneLabelsFailed,
  selectSceneLabelsLoaded,
} from '../redux/slicers/configurator/configuratorSceneLabels.slicer';
import {
  PRESET_CAMERA_ANGLE,
  apiDelete,
  apiDeleteV2,
  apiGet,
  apiGetMaterials,
  apiGetTextureList,
  apiMultiDelete,
  apiPatch,
  apiPost,
  apiPostV2,
} from '../helpers/api';
import { configuratorLightingActions } from '../redux/slicers/configurator/configuratorLighting.slicer';
import { errorToastV2, successToastV2 } from '../helpers/toastHelper';
import {
  configuratorViewBackgroundActions,
  selectBackgroundData,
  selectBackgroundError,
  selectBackgroundLoaded,
} from '../redux/slicers/configurator/configuratorViewBackground.slicer';
import { fetchAllPages } from '../helpers/apiHelper';
import { LabelsController } from '../components/Configurator/unity/unityMethods';
import { loadSceneLabels } from '../redux/slicers/configurator/configurator.actions';
import axios from 'axios';
import { dispatcher } from '../helpers/projectHelper';
import {
  enableBackgroundInViewsAfterUpdate,
  getInitialPropertiesIfDefaultIsPresent,
  isV2,
  resetSelectedTexture,
} from '../components/Configurator/utils';
import { configuratorLightingPopupActions } from '../redux/slicers/configurator/configuratorLightingPopup.slicer';

const calculateOptimisticRevert = ({ prevData, nextData }) => {
  const revertData = Object.keys(nextData).reduce((acc, key) => {
    acc[key] = prevData[key];
    return acc;
  }, {});
  return revertData;
};

export const getConfiguratorsApi = createGetListAction({
  endpoint: GET_CONFIGURATOR_API,
  actions: productConfiguratorsActions,
  setGlobalSidebarFilters: true,
});

export const configuratorUpdateApi = createUpdateApiAction({
  actions: productConfiguratorsActions,
  endpointUrl: GET_CONFIGURATOR_API,
});

export const configuratorUpdateApiV2 = createUpdateApiAction({
  actions: productConfiguratorsActions,
  endpointUrl: GET_CONFIGURATOR_API_V2,
});

export const deleteConfiguratorAPI = createDeleteApiAction({
  actions: productConfiguratorsActions,
  endpointUrl: GET_CONFIGURATOR_API_V2,
  optimistic: false,
  successMessage: 'Configurator deleted successfully',
});

export const getConfiguratorLightingApi = createGetListAction({
  endpoint: GET_CONFIGURATOR_LIGHTING_API,
  actions: configuratorLightingActions,
});

export const getConfiguratorLightingApiV2 = createGetListAction({
  endpoint: GET_CONFIGURATOR_LIGHTING_API_V2,
  actions: configuratorLightingActions,
});

export const getConfiguratorLightingApiV2Popup = createGetListAction({
  endpoint: GET_CONFIGURATOR_LIGHTING_API_V2,
  actions: configuratorLightingPopupActions,
});

export function createConfiguratorApi({
  name,
  // type,
  aspectRatio,
}) {
  const data = {
    name,
    // config_type: type,
    is_new_configurator: true,
  };
  if (!isEmpty(aspectRatio)) {
    data.aspect_ratio = aspectRatio?.aspect_ratio;
    data.compressed_reso_x = aspectRatio?.compressed_reso_x;
    data.compressed_reso_y = aspectRatio?.compressed_reso_y;
    data.bg_reso_x = aspectRatio?.high_reso_x;
    data.bg_reso_y = aspectRatio?.high_reso_y;
    data.high_reso_x = aspectRatio?.high_reso_x;
    data.high_reso_y = aspectRatio?.high_reso_y;
    data.low_reso_x = aspectRatio?.low_reso_x;
    data.low_reso_y = aspectRatio?.low_reso_y;
    data.preview_reso_x = aspectRatio?.low_reso_x;
    data.preview_reso_y = aspectRatio?.low_reso_y;
    data.render_reso_x = aspectRatio?.high_reso_x;
    data.render_reso_y = aspectRatio?.high_reso_y;
  }
  return apiPostV2(GET_CONFIGURATOR_API_V2, { data }).send();
}

export const deleteMultipleConfiguratorsApi = (
  payload,
  successMessage = 'Configurators deleted successfully',
  errorMessage = 'Unable to delete configurators: Renders in progress'
) => {
  return apiMultiDelete(
    GET_CONFIGURATOR_API_V2,
    payload,
    'apiDeleteConfigurators',
    successMessage,
    errorMessage
  );
};

export const deleteConfiguratorApi = (configuratorId) => async (dispatch) => {
  configuratorId = configuratorId || selectConfiguratorId(getAppState());
  const payload = new FormData();
  payload.append('id', configuratorId);
  const url = GET_CONFIGURATOR_API_V2;
  const result = await apiDeleteV2(url, {
    showErrorToast: false,
  })
    .data(payload)
    .send();
  return result;
};

export function createSceneApi({ name, configuratorId, errorMessage }) {
  return apiPostV2(isV2() ? CREATE_CONFIGURATOR_SCENE_API_V2 : CREATE_CONFIGURATOR_SCENE_API, {
    data: { name, configurator: configuratorId },
    errorMessage,
  }).send();
}

export function duplicateSceneApi({ sceneId, configuratorDuplicateId, errorMessage, v2 }) {
  const data = { scene: sceneId };
  if (configuratorDuplicateId) {
    data.configurator_duplicate_id = configuratorDuplicateId;
    data.is_config_duplicate = true;
  }
  return apiPostV2(
    v2 || isV2() ? DUPLICATE_CONFIGURATOR_SCENE_API_V2 : DUPLICATE_CONFIGURATOR_SCENE_API,
    {
      data,
      errorMessage,
      isFormData: true,
    }
  ).send();
}

export const updateConfiguratorData = async ({ id, payload }) => {
  const configuratorId = id || selectConfiguratorId(getAppState());
  const data = {
    id: configuratorId,
    ...payload,
  };
  const url = `${isV2() ? GET_CONFIGURATOR_API_V2 : GET_CONFIGURATOR_API}${configuratorId}/`;
  const result = await apiPatch(url, data);
  // TODO: handle error handling here and revert if error
  if (!result) {
    errorToastV2('Something went wrong. Please try again.');
  } else {
    if (typeof payload?.font_settings === 'string') {
      payload.font_settings = JSON.parse(payload?.font_settings);
    }
    if (typeof payload?.theme_settings === 'string') {
      payload.theme_settings = JSON.parse(payload?.theme_settings);
    }
    dispatcher(configuratorActions.updateData(payload));
  }
  return result;
};

export function duplicateConfiguratorApi({ configuratorId, v2 = false, otherData, errorMessage }) {
  return apiPostV2(isV2() || v2 ? DUPLICATE_CONFIGURATOR_API_V2 : DUPLICATE_CONFIGURATOR_API, {
    data: { configurator: configuratorId, ...otherData },
    errorMessage,
    isFormData: true,
  }).send();
}

export const deleteSceneOptimisticApi = (sceneId) => async (dispatch) => {
  const scene = selectSceneById(sceneId)(getAppState());
  dispatch(configuratorActions.deleteScene(sceneId));
  const mainUrl = isV2() ? UPDATE_CONFIGURATOR_SCENE_API_V2 : UPDATE_CONFIGURATOR_SCENE_API;
  const url = mainUrl.replace(':sceneId', sceneId);
  const result = await apiDelete(url, 'deleteSceneOptimisticApi');
  if (!result?.status) {
    dispatch(configuratorActions.addScene(scene));
  } else {
    successToastV2(`${scene?.name || 'Scene'} deleted successfully`);
  }
  // TODO: revert if fails
};

export const updateConfiguratorOptimistic =
  (data, v2 = false) =>
  async (dispatch) => {
    const configuratorId = selectConfiguratorId(getAppState());
    const prevData = selectConfiguratorData(getAppState());
    data = { id: configuratorId, ...data };
    const optimisticData = { ...data };
    let thumb = data.thumb;
    const watermark = data.watermark;
    const downloadIcon = data.download_icon;
    let watermarkUrl = '';
    let downloadIconUrl = '';
    let thumbUrl = '';
    if (thumb instanceof File) {
      thumbUrl = URL.createObjectURL(thumb);
      optimisticData.thumb = thumbUrl;
    }
    if (watermark instanceof File) {
      watermarkUrl = URL.createObjectURL(watermark);
      optimisticData.watermark = watermarkUrl;
    }
    if (downloadIcon instanceof File) {
      downloadIconUrl = URL.createObjectURL(downloadIcon);
      optimisticData.download_icon = downloadIconUrl;
    }
    dispatch(configuratorActions.updateConfigurator(optimisticData));
    const url = `${isV2() || v2 ? GET_CONFIGURATOR_API_V2 : GET_CONFIGURATOR_API}${data.id}/`;
    try {
      const updatedData = await apiPatch(url, data, 'updateConfiguratorOptimistic');
      if (!updatedData) {
        throw new Error();
      }
      dispatch(configuratorActions.updateConfigurator(updatedData.data));
    } catch (error) {
      // todo handle error here correctly
      if (watermarkUrl) {
        errorToastV2('An error occured while uploading watermark. Please try again.');
      } else {
        errorToastV2('An error occured while updating configurator. Please try again.');
      }
      const revertData = calculateOptimisticRevert({ prevData, nextData: data });
      dispatch(configuratorActions.updateConfigurator(revertData));
    }
    if (watermarkUrl) {
      URL.revokeObjectURL(watermarkUrl);
    }
    // TODO: revert data back on error
  };

export const getConfiguratorApi =
  (payload, flag = true) =>
  (dispatch) => {
    const mockDataFetching = async () => {
      if (flag) {
        dispatch(configuratorActions.fetchDataStart(true));
      }
      const url = `${GET_CONFIGURATOR_API}${payload.configuratorId}/`;
      // TODO: add error handling
      const configurator = await apiGet(url);
      if (configurator) {
        dispatch(configuratorActions.fetchDataSuccess(configurator));
        return configurator;
      } else {
        dispatch(configuratorActions.fetchDataFailed());
      }
    };
    return mockDataFetching();
  };

export const getConfiguratorScenes =
  (configuratorId, flag = true) =>
  (dispatch) => {
    if (!configuratorId) {
      configuratorId = selectConfiguratorId(getAppState());
    }
    const mockDataFetching = async () => {
      if (flag) dispatch(configuratorActions.fetchScenesStart());
      const mainUrl = isV2() ? GET_CONFIGURATOR_SCENE_LIST_API_V2 : GET_CONFIGURATOR_SCENE_LIST_API;
      const url = `${mainUrl}?configurator=${configuratorId}`;
      const result = await fetchAllPages((page) => {
        const paginatedUrl = `${url}&page=${page}`;
        return apiGet(paginatedUrl);
      });
      if (result?.results) {
        dispatch(configuratorActions.fetchScenesSuccess(result.results));
        return result.results;
      } else {
        dispatch(configuratorActions.fetchScenesFailed());
      }
    };
    return mockDataFetching();
  };

export const changeScenesOrder =
  ({ scenes }) =>
  (dispatch) => {
    // data is an array with  id and new order number
    const mockDataFetching = async () => {
      dispatch(configuratorActions.updateScenes({ scenes }));
      const payload = new FormData();
      scenes.map((s) => {
        payload.append('id', s.id);
        payload.append('seq_no', s.seq_no);
      });
      // TODO: when API is ready -> change order to previous if it fails
      const result = await apiPatch(
        isV2() ? REORDER_CONFIGURATOR_SCENE_API_V2 : REORDER_CONFIGURATOR_SCENE_API,
        payload,
        'changeScenesOrder',
        null,
        null,
        false
      );
      if (!result.status || !Array.isArray(result.data)) {
        // TODO: handle error;
        return;
      }
      dispatch(configuratorActions.updateScenes({ scenes: result.data }));
      return;
    };
    return mockDataFetching();
  };

export const getConfiguratorCameraPresetsApi = (configuratorId) => (dispatch) => {
  configuratorId = configuratorId || selectConfiguratorId(getAppState());
  const mockDataFetching = async () => {
    dispatch(configuratorCameraActions.fetchCameraPresetsStart());
    let url = `${GET_CONFIGURATOR_CAMERA_PRESETS_API}?`;
    if (configuratorId) {
      url = url.replace(':configuratorId', configuratorId);
    }
    const result = await apiGet(url);
    let presets = result?.results;
    if (!presets) {
      dispatch(configuratorCameraActions.fetchCameraPresetsFailed());
      return;
    }
    dispatch(configuratorCameraActions.fetchCameraPresetsSuccess(presets));
    return presets;
  };
  return mockDataFetching();
};

export const updateCameraPresetOptimistic =
  ({ cameraData }) =>
  (dispatch) => {
    const mockDataFetching = async () => {
      const prevCamera = selectCameraPreset(cameraData.id)(getAppState());
      dispatch(configuratorCameraActions.updateCameraPreset(cameraData));
      const url = UPDATE_CONFIGURATOR_CAMERA_PRESETS_API.replace(':presetId', cameraData.id);
      const updatedCamera = await apiPatch(url, cameraData);
      if (!updatedCamera?.id) {
        const revertData = calculateOptimisticRevert({
          prevData: prevCamera,
          nextData: cameraData,
        });
        dispatch(configuratorCameraActions.updateCameraPreset(revertData));
        return;
      }
      // TODO: check if error toasts works correctly here
      return updatedCamera;
    };
    return mockDataFetching();
  };

export const deleteCameraPresetOptimisticApi = (id) => async (dispatch) => {
  const cameraPreset = selectCameraPreset(id)(getAppState());
  dispatch(configuratorCameraActions.deleteCameraPreset(id));
  const url = UPDATE_CONFIGURATOR_CAMERA_PRESETS_API.replace(':presetId', cameraPreset.id);
  const result = await apiDeleteV2(url, {
    errorMessage: 'An error occured while deleting camera preset. Please try again.',
  }).send();
  if (!result?.status) {
    dispatch(configuratorCameraActions.addCameraPreset(cameraPreset));
  } else {
    successToastV2(`Camera preset "${cameraPreset.cameraName}" was deleted`);
  }
};

export const updateSceneOptimistic =
  ({ id, ...data }) =>
  (dispatch) => {
    const mockDataFetching = async () => {
      const {
        json_file_content,
        thumb,
        main_product_id,
        sceneproduct,
        threed_viewer_file,
        callback,
        ...rest
      } = data;
      // TODO: work on this logic
      const updateData = {
        id,
        ...rest,
      };
      if (json_file_content) {
        updateData.json_file_content = json_file_content;
      }
      let thumbUrl;
      let threeDUrl;
      if (thumb) {
        // add temporary thumbnail
        thumbUrl = URL.createObjectURL(thumb);
        updateData.thumb = thumbUrl;
      }
      if (threed_viewer_file) {
        // add temporary thumbnail
        threeDUrl = URL.createObjectURL(threed_viewer_file);
        updateData['3d_viewer_file'] = threeDUrl;
      }
      dispatch(configuratorActions.updateScene(updateData));
      if (json_file_content) {
        const jsonBlob = new Blob([JSON.stringify(json_file_content)], {
          type: 'application/json',
        });
        delete updateData.json_file_content;
        updateData.json_file = jsonBlob;
      }
      if (thumb) {
        updateData.thumb = thumb;
      }
      if (threed_viewer_file) {
        updateData.threed_viewer_file = threed_viewer_file;
      }
      if (main_product_id) {
        updateData.main_product_id = main_product_id;
      }
      if (main_product_id === null) {
        updateData.main_product_id = '';
      }
      if (thumb === null) {
        updateData.thumb = '';
      }
      if (threed_viewer_file === null) {
        updateData.threed_viewer_file = '';
      }
      const mainUrl = isV2() ? UPDATE_CONFIGURATOR_SCENE_API_V2 : UPDATE_CONFIGURATOR_SCENE_API;
      const url = mainUrl.replace(':sceneId', id);
      const formData = objectToFormData(updateData);
      if (sceneproduct) {
        if (sceneproduct.length) {
          sceneproduct.map((val) => {
            formData.append('sceneproduct', val ? val : '');
            return val;
          });
        } else {
          formData.append('sceneproduct', '');
        }
      }
      const result = await apiPatch(url, formData, '', '', '', false);
      if (!result) {
        // TODO: revert back
        return result;
      }
      dispatch(configuratorActions.updateScene(result));
      if (thumb) {
        URL.revokeObjectURL(thumbUrl);
      }
      if (threed_viewer_file) {
        URL.revokeObjectURL(threeDUrl);
      }
      if (callback) {
        callback();
      }
      // TODO: if api call fails -> revert changes
      return result;
    };
    return mockDataFetching();
  };

export const updateViewOptimistic =
  ({ sceneId, view }) =>
  (dispatch) => {
    const mockDataFetching = async () => {
      const prevView = selectSceneView(sceneId, view.id)(getAppState());
      dispatch(
        configuratorSceneViewsActions.updateView({
          sceneId,
          view,
        })
      );
      const mainUrl = isV2() ? UPDATE_CONFIGURATOR_VIEW_API_V2 : UPDATE_CONFIGURATOR_VIEW_API;
      const url = mainUrl.replace(':viewId', view.id);
      const data = { ...view };
      delete data?.id;
      const result = await apiPatch(
        url,
        data,
        'updateViewOptimistic',
        null,
        null,
        true,
        false,
        false
      );
      if (!result?.id) {
        const revertData = calculateOptimisticRevert({ prevData: prevView, nextData: view });
        dispatch(configuratorSceneViewsActions.updateView({ sceneId, view: revertData }));
      }
      // TODO: check if error toasts works correctly here
      const selectedView = selectSelectedViewInScene(sceneId)(getAppState());
      if (!isEmpty(selectedView) && parseInt(result?.id) === parseInt(selectedView?.id)) {
        dispatch(configuratorSceneViewsActions.setSelectedViewInScene({ sceneId, view: result }));
      }
      return result;
    };
    return mockDataFetching();
  };

export const updateViewTransformationOptimistic =
  ({ sceneId, view }) =>
  (dispatch) => {
    const mockDataFetching = async () => {
      const prevView = selectSceneView(sceneId, view.id)(getAppState());
      dispatch(
        configuratorSceneViewsActions.updateView({
          sceneId,
          view,
        })
      );
      const mainUrl = isV2() ? UPDATE_CONFIGURATOR_VIEW_API_V2 : UPDATE_CONFIGURATOR_VIEW_API;
      const url = mainUrl.replace(':viewId', view.id);
      const result = await apiPatch(url, {
        id: view.id,
        extra_data: JSON.stringify(view.extra_data || {}),
      });
      if (!result?.id) {
        const revertData = calculateOptimisticRevert({ prevData: prevView, nextData: view });
        dispatch(configuratorSceneViewsActions.updateView({ sceneId, view: revertData }));
      }
      // TODO: check if error toasts works correctly here
      return result;
    };
    return mockDataFetching();
  };

export const updateViewsOptimistic =
  ({ sceneId, views }) =>
  (dispatch) => {
    const mockDataFetching = async () => {
      dispatch(
        configuratorSceneViewsActions.updateViews({
          sceneId,
          views,
        })
      );
      await waitRandom(0, 1000);
      // TODO: if api call fails -> revert changes
      return;
    };
    return mockDataFetching();
  };

export const deleteViewOptimisticApi =
  ({ sceneId, viewId }) =>
  async (dispatch) => {
    const view = selectSceneView(sceneId, viewId)(getAppState());
    const selected = selectSelectedViewInScene(sceneId)(getAppState());
    const mainUrl = isV2() ? DELETE_CONFIGURATOR_VIEW_API_V2 : DELETE_CONFIGURATOR_VIEW_API;
    const url = mainUrl.replace(':viewId', viewId);
    const result = await apiDelete(url, 'deleteViewOptimisticApi');
    if (!result?.status) {
      dispatch(
        configuratorSceneViewsActions.addViewsToScene({
          sceneId,
          views: [view],
        })
      );
    } else {
      dispatch(configuratorSceneViewsActions.deleteViews({ sceneId, ids: [viewId] }));
      if (view.id === selected?.id) {
        const views = selectCurrentSceneViews(getAppState());
        dispatch(
          configuratorSceneViewsActions.setSelectedViewInScene({
            sceneId,
            view: views?.length ? views[0] : {},
          })
        );
      }
      successToastV2(`${view?.name || 'View'} deleted successfully`);
    }
    // TODO: revert if fails
  };

export const getSceneViewsApi =
  ({ sceneId, showLoading = true, onlyOnce }) =>
  (dispatch, getState) => {
    const mockDataFetching = async () => {
      if (onlyOnce) {
        const loaded = selectSceneViewsLoaded(sceneId)(getState());
        const failed = selectFailedToLoadViews(sceneId)(getState());
        if (loaded && !failed) return;
      }
      showLoading && dispatch(configuratorSceneViewsActions.fetchSceneViewsStart({ sceneId }));
      const url = `${
        isV2() ? GET_CONFIGURATOR_VIEW_LIST_API_V2 : GET_CONFIGURATOR_VIEW_LIST_API
      }?scene=${sceneId}`;
      const result = await fetchAllPages((page) => {
        const paginatedUrl = `${url}&page=${page}`;
        return apiGet(paginatedUrl);
      });
      const views = enableBackgroundInViewsAfterUpdate(result?.results || []);
      if (views) {
        dispatch(
          configuratorSceneViewsActions.fetchSceneViewsSuccess({
            sceneId,
            views: views,
          })
        );
        const selectedView = selectSelectedViewInScene(sceneId)(getAppState());
        if (!isEmpty(selectedView)) {
          const view = views.find((val) => parseInt(val?.id) === parseInt(selectedView?.id));
          view &&
            dispatcher(configuratorSceneViewsActions.setSelectedViewInScene({ sceneId, view }));
        }
      } else {
        dispatch(configuratorSceneViewsActions.fetchSceneViewsFailed({ sceneId }));
      }
      return result;
    };
    return mockDataFetching();
  };

export const createBackgroundApi =
  ({
    sceneId,
    viewId,
    is_apply_all,
    bg_color,
    bg_file,
    bg_type,
    scale,
    position_x = 0,
    position_y = 0,
    errorMessage,
  }) =>
  async (dispatch) => {
    let dataToPass = { scene: sceneId, view_id: viewId };
    if (bg_file) {
      dataToPass['bg_file'] = bg_file;
      dataToPass['scale'] = scale;
      dataToPass['bg_type'] = '1';
      dataToPass['position_x'] = position_x;
      dataToPass['position_y'] = position_y;
    }
    if (bg_color) {
      dataToPass['bg_color'] = bg_color;
      dataToPass['bg_type'] = '2';
    }
    if (bg_type) {
      dataToPass['bg_type'] = bg_type;
    }
    if (typeof bg_file === 'string') {
      delete dataToPass?.bg_file;
    }
    if (is_apply_all) {
      dataToPass['is_apply_all'] = true;
    }
    const result = await apiPostV2(
      isV2() ? GET_CONFIGURATOR_BACKGROUND_LIST_API_V2 : GET_CONFIGURATOR_BACKGROUND_LIST_API,
      {
        data: dataToPass,
        errorMessage,
      }
    ).send();
    const background = result?.data;
    if (!background) {
      errorToastV2(errorMessage);
      return;
    }
    dispatch(
      configuratorViewBackgroundActions.fetchBackgroundSuccess({
        id: background.id,
        data: background,
      })
    );
    dispatch(
      configuratorSceneViewsActions.updateView({
        sceneId,
        view: {
          id: viewId,
          original_bg: background.id,
          latest_bg: background.id,
          latest_bg_detail: background,
        },
      })
    );
    return background;
  };

export const getBackgroundApi =
  ({ backgroundId, onlyOnce }) =>
  (dispatch, getState) => {
    const mockDataFetching = async () => {
      if (onlyOnce) {
        const loaded = selectBackgroundLoaded(backgroundId)(getState());
        const failed = selectBackgroundError(backgroundId)(getState());
        if (loaded && !failed) return;
      }
      dispatch(configuratorViewBackgroundActions.fetchBackgroundStart({ id: backgroundId }));
      const mainUrl = isV2()
        ? UPDATE_CONFIGURATOR_BACKGROUND_API_V2
        : UPDATE_CONFIGURATOR_BACKGROUND_API;
      const url = mainUrl.replace(':bgId', backgroundId);
      const background = await apiGet(url);
      if (background?.id) {
        dispatch(
          configuratorViewBackgroundActions.fetchBackgroundSuccess({
            id: backgroundId,
            data: background,
          })
        );
      } else {
        dispatch(configuratorViewBackgroundActions.fetchBackgroundFailed({ id: backgroundId }));
      }
      return;
    };
    return mockDataFetching();
  };

export const updateBgOptimisticApi =
  ({ data, viewId }) =>
  (dispatch) => {
    const mockDataFetching = async () => {
      const prevData = selectBackgroundData(data.id)(getAppState());
      const optimisticData = {
        ...data,
        // ...(data.bg_file && { bg_file: null }),
        // ...(data.bg_crop_file && { bg_crop_file: null }),
      };
      dispatch(configuratorViewBackgroundActions.updateBackground(optimisticData));
      const mainUrl = isV2()
        ? UPDATE_CONFIGURATOR_BACKGROUND_API_V2
        : UPDATE_CONFIGURATOR_BACKGROUND_API;
      const url = mainUrl.replace(':bgId', data.id);
      const response = await apiPatch(url, { ...data, view_id: viewId });
      const bg = response?.data;
      if (!bg?.id) {
        const revertData = calculateOptimisticRevert({ prevData, nextData: data });
        dispatch(configuratorViewBackgroundActions.updateBackground(revertData));
        return;
      }
      dispatch(configuratorViewBackgroundActions.updateBackground(bg));
      if (typeof data.is_apply_all === 'boolean') {
        const sceneId = selectSelectedSceneId(getAppState());
        const views = selectCurrentSceneViews(getAppState());
        // is_apply_all was changed
        if (data.is_apply_all) {
          // activated
          const updatedViews = views.map((v) => ({
            id: v.id,
            latest_bg: bg.id,
          }));
          dispatch(
            configuratorSceneViewsActions.updateViews({
              sceneId,
              views: updatedViews,
            })
          );
        } else {
          // disabled
          // apply all background properties to view backgrounds
          // skip properties id, name, scene
          const applyToAllBg = { ...bg };
          delete applyToAllBg.id;
          delete applyToAllBg.name;
          delete applyToAllBg.scene;
          views.forEach((view) => {
            if (!view.original_bg) return;
            dispatch(
              configuratorViewBackgroundActions.updateBackground({
                id: view.original_bg,
                ...applyToAllBg,
              })
            );
          });
        }
      }
      // TODO: check if error toasts works correctly here
      return bg;
    };

    return mockDataFetching();
  };

export const getLabelsApi = async ({ sceneId }) => {
  const mainUrl = isV2() ? GET_CONFIGURATOR_LABELS_V2 : GET_CONFIGURATOR_LABELS;
  const url = mainUrl + `?scene=${sceneId}`;
  const result = await fetchAllPages((page) => {
    const paginatedUrl = `${url}&page=${page}`;
    return apiGet(paginatedUrl);
  });
  return result?.results || [];
};

export const getOptionsApi = async ({ sceneId, labelId, extraParams = {} }) => {
  let url = `${isV2() ? GET_LABEL_OPTIONS_API_V2 : GET_LABEL_OPTIONS_API}?sceneoption=${labelId}${
    isV2() ? `&scene=${sceneId}` : ''
  }`;
  const sortBy = selectConfiguratorSortBy(getAppState());
  if (sortBy !== DEFAULT_SORT_BY) {
    extraParams = {
      ...extraParams,
      sort: sortBy,
    };
  }
  if (extraParams) {
    const keys = Object.keys(extraParams);
    keys.map((key) => {
      url += `&${key}=${extraParams[key]}`;
    });
  }
  const result = await apiGet(url);
  return result;
};

export const getSceneLabelsApi =
  ({ sceneId, onlyOnce, onlyRedux = false }) =>
  (dispatch, getState) => {
    const mockDataFetching = async () => {
      if (onlyOnce) {
        const loaded = selectSceneLabelsLoaded(sceneId)(getState());
        const failed = selectSceneLabelsFailed(sceneId)(getState());
        if (loaded && !failed) {
          return selectSceneLabels(sceneId)(getAppState());
        }
      }
      if (!onlyRedux) {
        dispatch(configuratorSceneLabelsActions.fetchSceneLabelsStart({ sceneId }));
      }
      const labels = await getLabelsApi({ sceneId });
      if (labels) {
        dispatch(
          configuratorSceneLabelsActions.fetchSceneLabelsSuccess({
            sceneId,
            labels,
          })
        );
        return labels;
      } else {
        dispatch(configuratorSceneLabelsActions.fetchSceneLabelsFailed({ sceneId }));
      }
      // TODO: handle errors
      return;
    };
    return mockDataFetching();
  };

export const getLabelOptions =
  ({ labelId, onlyOnce, scene, onlyRedux = false, skipDefaultTextures = false, extraParams }) =>
  (dispatch, getState) => {
    const mockDataFetching = async () => {
      if (onlyOnce) {
        const loaded = selectLabelOptionsLoaded(labelId)(getState());
        const failed = selectLabelOptionsError(labelId)(getState());
        if (loaded && !failed) return;
      }
      if (!onlyRedux) {
        dispatch(configuratorLabelDetailsActions.fetchLabelOptionsStart({ labelId }));
      }
      const sceneId = scene || selectSelectedSceneId(getAppState());
      const result = await getOptionsApi({ labelId, sceneId, extraParams });
      let options = result?.results;
      if (!skipDefaultTextures) {
        const defaultOptions = await getDefaultTextures({ labelId });
        if (defaultOptions?.length) {
          getInitialPropertiesIfDefaultIsPresent({ options: defaultOptions });
        }
      }
      if (options) {
        options = options.map((op, index) => {
          return { ...op, rank: index + 1 };
        });
        dispatch(
          configuratorLabelDetailsActions.fetchLabelOptionsSuccess({
            labelId,
            options,
          })
        );
        if (result?.next_link) {
          dispatch(
            configuratorLabelDetailsActions.setLabelNextPage({ sceneId, labelId, nextPage: 2 })
          );
        } else {
          dispatch(
            configuratorLabelDetailsActions.setLabelNextPage({ sceneId, labelId, nextPage: null })
          );
        }
      } else {
        dispatch(configuratorLabelDetailsActions.fetchLabelOptionsFailed({ labelId }));
      }
      return result;
    };
    return mockDataFetching();
  };

export const changeLabelsOrder =
  ({ data, sceneId }) =>
  (dispatch) => {
    // data is an array with label id and new order number
    const mockDataFetching = async () => {
      dispatch(
        configuratorSceneLabelsActions.changeLabelsOrder({
          sceneId,
          labels: data,
        })
      );
      await waitRandom(0, 500);
      // TODO: when API is ready -> change order to previous if it fails
      return;
    };
    return mockDataFetching();
  };

export const addLabel =
  ({ labelName, sceneId, configuratorId, isTransparentFinish }) =>
  (dispatch) => {
    const mockDataFetching = async () => {
      const label = {
        // id: uuidv4(),
        name: labelName,
        is_enable: true,
        // linkedObjects: linkedObjects,
        scene: sceneId,
        is_transparent_finish: isTransparentFinish,
        // data: JSON.stringify({
        //   linkedObjects,
        // })
        // order: lastOption ? lastOption.order + 1 : 1,
      };
      if (isV2()) {
        label.configurator = configuratorId || selectConfiguratorId(getAppState());
        label.data = JSON.stringify([
          {
            linkedObjects: [],
            is_transparent_finish: isTransparentFinish,
            is_enable: true,
            scene: sceneId,
          },
        ]);
        delete label?.is_enable;
        delete label?.is_transparent_finish;
        delete label?.scene;
      }
      const url = isV2() ? CREATE_CONFIGURATOR_LABEL_V2 : CREATE_CONFIGURATOR_LABEL;
      const result = await apiPostV2(url, { data: label }).send();
      const createdLabel = result?.data;
      if (createdLabel) {
        dispatch(
          configuratorSceneLabelsActions.addLabelsToScene({
            sceneId,
            labels: [createdLabel],
          })
        );
        successToastV2('Label added successfully');
        return createdLabel;
      }
      // TODO: handle error
    };
    return mockDataFetching();
  };

export const updateLabel =
  ({ data, sceneId }) =>
  (dispatch) => {
    const mockDataFetching = async () => {
      const mainUrl = isV2() ? UPDATE_CONFIGURATOR_LABEL_API_V2 : UPDATE_CONFIGURATOR_LABEL_API;
      const url = mainUrl.replace(':labelId', data?.id);
      if (isV2() && data?.data) {
        data.data = JSON.stringify([data.data]);
      }
      const result = await apiPatch(url, data);
      if (result?.data?.id) {
        dispatch(
          configuratorSceneLabelsActions.updateLabel({
            sceneId,
            label: result?.data,
          })
        );
      }
      return;
    };
    return mockDataFetching();
  };

export const duplicateLabel =
  ({ id, sceneId }) =>
  (dispatch) => {
    const mockDataFetching = async () => {
      const obj = {
        sceneoption: id,
      };
      if (isV2()) {
        obj.configurator = selectConfiguratorId(getAppState());
      }
      const result = await apiPost(
        isV2() ? SCENE_OPTION_DUPLICATE_API_V2 : SCENE_OPTION_DUPLICATE_API,
        obj,
        'duplicateLabel',
        null,
        null,
        true
      );
      if (result?.data?.length) {
        await loadSceneLabels({ sceneId, onlyOnce: false });
        dispatch(getLabelOptions({ labelId: result?.data[0]?.id, onlyOnce: false }));
      }
    };
    mockDataFetching();
  };

export const updateLabelsOptimistic =
  ({ sceneId, updatedLabels }) =>
  (dispatch) => {
    const mockDataFetching = async () => {
      const result = await apiPatch(
        isV2() ? UPDATE_CONFIGURATOR_LABELS_API_V2 : UPDATE_CONFIGURATOR_LABELS_API,
        updatedLabels,
        'updateLabelsOptimistic',
        null,
        null,
        false
      );
      if (result?.data?.length) {
        dispatch(
          configuratorSceneLabelsActions.updateLabels({
            sceneId,
            labels: result?.data,
          })
        );
        await Promise.all(
          result?.data?.map(async (val) => {
            const linkedObjects = val?.data?.linkedObjects;
            if (!linkedObjects?.length) {
              await resetSelectedTexture({ labelId: val?.id });
              // dispatcher(
              //   configuratorActions.setSelectedOption({
              //     labelId: val?.id,
              //     data: {},
              //     sceneId,
              //   })
              // );
            }
          })
        );
      }
      // TODO: if api call fails -> revert changes
      return;
    };
    return mockDataFetching();
  };

// export const updateLabelOptimistic =
//   ({ sceneId, ...labelData }) =>
//   (dispatch) => {
//     const mockDataFetching = async () => {
//       const prevLabel = selectLabelById(labelData.id, sceneId)(getAppState());
//       dispatch(
//         configuratorSceneLabelsActions.updateLabel({
//           sceneId,
//           label: labelData,
//         })
//       );
//       const payload = { ...labelData };
//       if (labelData.data) {
//         payload.data = JSON.stringify(labelData.data);
//       }
//       const mainUrl = isV2() ? UPDATE_CONFIGURATOR_LABEL_API_V2 : UPDATE_CONFIGURATOR_LABEL_API;
//       const url = mainUrl.replace(':labelId', labelData.id);
//       const result = await apiPatch(url, payload);
//       const label = result?.data;
//       if (label?.id) {
//         dispatch(
//           configuratorSceneLabelsActions.updateLabel({
//             sceneId,
//             label,
//           })
//         );
//       } else {
//         const revertData = calculateOptimisticRevert({ prevData: prevLabel, nextData: labelData });
//         dispatch(configuratorSceneLabelsActions.updateLabel({ sceneId, label: revertData }));
//       }
//       return;
//     };
//     return mockDataFetching();
//   };

export const deleteLabel =
  ({ sceneId, objectNames, id, callback }) =>
  (dispatch) => {
    const mockDataFetching = async () => {
      const mainUrl = isV2() ? DELETE_CONFIGURATOR_LABEL_API_V2 : DELETE_CONFIGURATOR_LABEL_API;
      const url = mainUrl.replace(':labelId', id);
      const result = await apiDeleteV2(url, {
        errorMessage: 'An error occured while deleting label. Please try again.',
        successMessage: 'Label deleted successfully',
      }).send();
      if (result?.status) {
        if (typeof callback === 'function') {
          callback();
        }
        LabelsController.UnlinkRenderersFromLabels(objectNames);
        dispatch(
          configuratorSceneLabelsActions.removeLabelsFromScene({
            sceneId,
            ids: [id],
          })
        );
      }
      return;
    };
    return mockDataFetching();
  };

export const changeLabelOptionsOrder =
  ({ data, labelId }) =>
  (dispatch) => {
    // data is an array with  id and new order number
    const mockDataFetching = async () => {
      const result = await apiPatch(
        isV2() ? UPDATE_LABEL_OPTIONS_API_V2 : UPDATE_LABEL_OPTIONS_API,
        JSON.stringify(data),
        'moveOptionsToLabel',
        null,
        null,
        false
      );
      if (result?.data?.length) {
        dispatch(
          configuratorLabelDetailsActions.updateLabelOptions({
            labelId,
            options: result.data,
          })
        );
      }
      return result;
    };
    return mockDataFetching();
  };

export const addOptionsToLabelApi =
  ({ labelId, options }) =>
  (dispatch) => {
    const mockDataFetching = async () => {
      // const currentOptions = selectLabelOptions(labelId)(getAppState());
      // TODO: add unique name geenration here
      const optionsWithData = await Promise.all(
        options.map(async (o) => {
          let baseOption = {
            texture_type: o.texture_type,
            is_enable: true,
            sceneoption_id: labelId,
          };
          if (isV2()) {
            baseOption.data = {
              scene_id: selectSelectedSceneId(getAppState()),
              is_enable: true,
            };
            baseOption.configurator_id = selectConfiguratorId(getAppState());
          }
          if (o.material_id || o.material_id === '') {
            baseOption.material_id = o.material_id;
          }
          if (o.extra_data) {
            baseOption.extra_data = o.extra_data;
          }
          if (o.material_properties) {
            baseOption.material_properties = o.material_properties;
          }
          if (o.texture_type === OPTION_TYPE.COLOR) {
            const color = paginatedColorSelector(getAppState()).list.find(
              (c) => parseInt(c.id) === parseInt(o.id)
            );
            baseOption.display_name = color.name || color.color_value;
            baseOption.color_code = color.color_value;
          } else if (o.texture_type === OPTION_TYPE.TEXTURE) {
            let texture = paginatedTexturesSelector(getAppState()).list.find(
              (t) => parseInt(t.id) === parseInt(o.id)
            );
            if (!texture) {
              const data = await apiGetTextureList({ query: `id=${o.id}` });
              if (data?.results?.length) {
                texture = data.results[0];
              }
            }
            baseOption.display_name = texture.name;
            baseOption.texture_id = texture.id;
          } else if (o.texture_type === OPTION_TYPE.MATERIAL) {
            let material = paginatedMaterialsSelector(getAppState()).list.find(
              (m) => parseInt(m.id) === parseInt(o.id)
            );
            if (!material) {
              const data = await apiGetMaterials(`id=${o.id}`);
              if (data?.results?.length) {
                material = data.results[0];
              }
            }
            baseOption.display_name = material.name;
            baseOption.material_id = material.id;
          } else {
            throw new Error('option type is not supported ' + o.texture_type);
          }
          return baseOption;
        })
      );
      const result = await apiPostV2(
        isV2() ? CREATE_LABEL_OPTIONS_API_V2 : CREATE_LABEL_OPTIONS_API,
        {
          data: JSON.stringify(optionsWithData),
          isFormData: false,
          // errorMessage: `An error occured while adding ${
          //   optionsWithData?.length > 1 ? 'finishes' : 'finish'
          // }. Please try again.`,
          // successMessage: `${optionsWithData?.length > 1 ? 'Finishes' : 'Finish'} added successfully`,
        }
      ).send();
      if (result?.data) {
        dispatch(
          configuratorLabelDetailsActions.addOptionsToLabel({
            labelId,
            options: result.data,
          })
        );
      } else {
        // TODO: revert
      }
      return;
    };
    return mockDataFetching();
  };

export const addDefaultMaterialToLabelApi =
  ({ labelId, options }) =>
  (dispatch) => {
    const mockDataFetching = async () => {
      // const currentOptions = selectLabelOptions(labelId)(getAppState());
      // TODO: add unique name geenration here
      if (isV2()) {
        options.map((val) => {
          const obj = {
            scene_id: selectSelectedSceneId(getAppState()),
            is_enable: true,
          };
          if ('is_selected' in val || (val?.data && 'is_selected' in val?.data)) {
            obj.is_selected = val?.data?.is_selected || val?.is_selected;
          }
          if ('is_default' in val || (val?.data && 'is_default' in val?.data)) {
            obj.is_default = val?.data?.is_default || val?.is_default;
          }
          if ('is_updated' in val || (val?.data && 'is_updated' in val?.data)) {
            obj.is_updated = val?.data?.is_updated || val?.is_updated;
          }
          if ('is_enable' in val || (val?.data && 'is_enable' in val?.data)) {
            obj.is_enable = val?.data?.is_enable || val?.is_enable;
          }
          if ('is_checked' in val || (val?.data && 'is_checked' in val?.data)) {
            obj.is_checked = val?.data?.is_checked || val?.is_checked;
          }
          val.configurator_id = selectConfiguratorId(getAppState());
          val.data = obj;
          return val;
        });
      }
      const result = await apiPostV2(
        isV2() ? UPLOAD_DEFAULT_TEXTURE_THUMBNAIL_V2 : UPLOAD_DEFAULT_TEXTURE_THUMBNAIL,
        {
          data: JSON.stringify(options),
          isFormData: false,
          // errorMessage: `An error occured while adding ${
          //   options?.length > 1 ? 'finishes' : 'finish'
          // }. Please try again.`,
        }
      ).send();
      if (result?.data) {
        const data = result?.data?.map((val) => {
          val.thumb = null;
          return val;
        });
        dispatch(
          configuratorLabelDetailsActions.addOptionsToLabel({
            labelId,
            options: data,
          })
        );
      } else {
        // TODO: revert
      }
      return result?.data;
    };
    return mockDataFetching();
  };

export const removeOptionsFromLabelOptimistic =
  ({ ids, labelId, showMessage = true }) =>
  async (dispatch) => {
    const options = selectLabelOptions(labelId)(getAppState());
    const deletedOptions = options.filter((o) => ids.includes(o.id));
    dispatch(
      configuratorLabelDetailsActions.removeOptionsFromLabel({
        labelId,
        ids,
      })
    );
    const payload = new FormData();
    if (isV2()) {
      const sceneId = selectSelectedSceneId(getAppState());
      payload.append('scene', sceneId);
    }
    ids.forEach((id) => payload.append('texture', id));
    const url = isV2() ? DELETE_LABEL_OPTIONS_API_V2 : DELETE_LABEL_OPTIONS_API;
    const result = await apiDeleteV2(url, {
      errorMessage: showMessage
        ? `An error occured while deleting ${
            ids?.length > 1 ? 'finishes' : 'finish'
          }. Please try again.`
        : null,
      successMessage: showMessage
        ? `${ids?.length > 1 ? 'Finishes' : 'Finish'} deleted successfully`
        : null,
    })
      .data(payload)
      .send();
    if (!result?.status) {
      dispatch(
        configuratorLabelDetailsActions.addOptionsToLabel({ labelId, options: deletedOptions })
      );
    }
  };

export const duplicateOptions =
  ({ options, labelId }) =>
  (dispatch) => {
    const mockDataFetching = async () => {
      const currentOptions = selectSortedLabelOptions(labelId)(getAppState());
      const updatedOptions = options.map((o, idx) => {
        const option = {
          ...o,
          sceneoption_id: labelId,
          display_name: generateNewName({
            items: currentOptions,
            baseName: o.display_name,
            nameKey: 'display_name',
          }),
        };
        if (!isEmpty(option.material_data)) {
          option.material_id = option.material_data.id || null;
        }
        if (!isEmpty(option.texture_data)) {
          option.texture_id = option.texture_data.id || null;
        }
        delete option.material_data;
        delete option.texture_data;
        delete option.id;
        delete option.order;
        delete option.created_at;
        delete option.updated_at;
        delete option.material;
        delete option.texture;
        delete option.sceneoption;
        delete option.seq_no;
        delete option.rank;
        delete option.configurator_texture_file;
        delete option.thumb;
        const objToReturn = {
          texture_type: parseInt(option.texture_type),
          display_name: option.display_name,
          sceneoption_id: option.sceneoption_id,
          sku_id: option.sku_id,
        };
        if (isV2()) {
          objToReturn.configurator_id = selectConfiguratorId(getAppState());
          objToReturn.data = {
            id: option.data.id,
            scene_id: selectSelectedSceneId(getAppState()),
          };
        }
        if (option.material_id) {
          objToReturn.material_id = option.material_id;
        }
        if (option.texture_id) {
          objToReturn.texture_id = option.texture_id;
        }
        if (option.color_code) {
          objToReturn.color_code = option.color_code;
        }
        if (option.material_properties) {
          objToReturn.material_properties = option.material_properties;
        }
        if (option.extra_data) {
          objToReturn.extra_data = option.extra_data;
        }
        if (option.is_default) {
          objToReturn.is_default = option.is_default;
          if (o.thumb) {
            objToReturn.thumb = o.thumb;
          }
        }
        if (option?.data?.is_default) {
          objToReturn.data.is_default = option.data.is_default;
          if (o.thumb) {
            objToReturn.thumb = o.thumb;
          }
        }
        if (option.is_checked) {
          objToReturn.is_checked = option.is_checked;
        }
        if (option?.data?.is_checked) {
          objToReturn.data.is_checked = option.data.is_checked;
        }
        return objToReturn;
      });
      const firstOption = options[0];
      const result = await apiPostV2(
        isV2() ? CREATE_LABEL_OPTIONS_API_V2 : CREATE_LABEL_OPTIONS_API,
        {
          data: JSON.stringify(updatedOptions),
          isFormData: false,
          errorMessage:
            firstOption.sceneoption === labelId
              ? 'An error occured while duplicating options. Please try again.'
              : 'An error occured while copying options. Please try again.',
        }
      ).send();
      // TODO: handle errors here
      if (result?.data) {
        dispatch(
          configuratorLabelDetailsActions.addOptionsToLabel({
            labelId,
            options: result.data,
          })
        );
      } else {
        // TODO: revert
      }
      return;
    };
    return mockDataFetching();
  };

export const moveOptionsToLabel =
  ({ options, labelId }) =>
  (dispatch) => {
    const mockDataFetching = async () => {
      // TODO: implement name generation
      // remove options from current label
      const ids = options.map((o) => o.id);
      dispatch(
        configuratorLabelDetailsActions.removeOptionsFromLabel({
          labelId: options[0].sceneoption,
          ids,
        })
      );
      const updatedOptions = options.map((o) => {
        const obj = {
          id: o.id,
          sceneoption: labelId,
        };
        if (isV2()) {
          obj.configurator_id = selectConfiguratorId(getAppState());
          obj.data = {
            id: o.data.id,
            scene_id: selectSelectedSceneId(getAppState()),
          };
        }
        return obj;
      });
      const result = await apiPatch(
        isV2() ? UPDATE_LABEL_OPTIONS_API_V2 : UPDATE_LABEL_OPTIONS_API,
        JSON.stringify(updatedOptions),
        'moveOptionsToLabel',
        null,
        null,
        false
      );
      if (result?.data) {
        dispatch(
          configuratorLabelDetailsActions.addOptionsToLabel({
            labelId,
            options: result.data,
          })
        );
      } else {
        // TODO: revert back if failed
      }
      return;
    };
    return mockDataFetching();
  };

export const updateOptionApi =
  ({ labelId, option, optionDataId }) =>
  (dispatch) => {
    const mockDataFetching = async () => {
      const baseMaterialData = option?.extra_data?.baseMaterialData;
      if (option.material_properties && typeof option.material_properties !== 'string') {
        if (baseMaterialData && !isEmpty(option?.material_properties)) {
          const objectName = baseMaterialData?.blenderObjectName || baseMaterialData?.objectName;
          option.material_properties.baseMaterialblenderObjectName = objectName || '';
        }
        option.material_properties = JSON.stringify(option.material_properties);
      }
      if (option.extra_data && typeof option.extra_data !== 'string') {
        option.extra_data = JSON.stringify(option.extra_data);
      }
      if (isV2() && optionDataId) {
        const obj = {
          id: optionDataId,
          scene_id: selectSelectedSceneId(getAppState()),
        };
        if ('is_selected' in option || (option?.data && 'is_selected' in option?.data)) {
          obj.is_selected = option?.data?.is_selected || option?.is_selected;
        }
        if ('is_default' in option || (option?.data && 'is_default' in option?.data)) {
          obj.is_default = option?.data?.is_default || option?.is_default;
        }
        if ('is_updated' in option || (option?.data && 'is_updated' in option?.data)) {
          obj.is_updated = option?.data?.is_updated || option?.is_updated;
        }
        if ('is_enable' in option || (option?.data && 'is_enable' in option?.data)) {
          obj.is_enable = option?.data?.is_enable || option?.is_enable;
        }
        if ('is_checked' in option || (option?.data && 'is_checked' in option?.data)) {
          obj.is_checked = option?.data?.is_checked || option?.is_checked;
        }
        option.configurator = selectConfiguratorId(getAppState());
        option.data = JSON.stringify(obj);
      }
      const mainUrl = isV2() ? UPDATE_LABEL_OPTION_API_V2 : UPDATE_LABEL_OPTION_API;
      const url = mainUrl.replace(':optionId', option.id);
      const result = await apiPatch(url, option);
      if (result?.id) {
        dispatch(
          configuratorLabelDetailsActions.updateLabelOption({
            labelId,
            option: result,
          })
        );
        if ('is_selected' in option) {
          const options = selectLabelOptions(labelId)(getAppState());
          const copyOptions = JSON.parse(JSON.stringify(options));
          copyOptions?.map((val) => {
            if (option?.id !== val?.id) {
              if (isV2()) {
                val.data.is_selected = false;
              } else {
                val.is_selected = false;
              }
            }
            return val;
          });
          dispatch(
            configuratorLabelDetailsActions.fetchLabelOptionsSuccess({
              labelId,
              options: copyOptions,
            })
          );
        }
        return result;
      }
      return false;
    };
    return mockDataFetching();
  };

export function saveConfiguratorAsTemplateApi({ configuratorId, name, errorMessage }) {
  return apiPostV2(SAVE_AS_TEMPLATE_CONFIGURATOR_API, {
    data: { configurator: configuratorId, template_name: name },
    errorMessage,
    isFormData: true,
  }).send();
}

export async function apiGetDownloadConfigurator(payload) {
  return apiPost(DOWNLOAD_CONFIGURATOR_API, payload, '', '', '', false);
}

export async function apiGetAllThemesConfigurator() {
  let result = await apiGet(GET_CONFIGURATOR_THEMES);
  return result;
}

export async function apiUpdateThemeToConfigurator(payload) {
  const result = await apiPatch(
    `${isV2() ? GET_CONFIGURATOR_API_V2 : GET_CONFIGURATOR_API}${payload.id}/`,
    {
      theme: payload.theme,
    }
  );
  return result;
}

export async function apiGetAllAspectRatio() {
  const result = await apiGet(GET_ALL_ASPECT_RATIO);
  return result;
}

export const apiGetConfiguratorTemplates = createGetListAction({
  endpoint: GET_ALL_TEMPLATES,
  actions: productConfiguratorsActions,
  setGlobalSidebarFilters: true,
});

export async function apiDeleteTemplate(payload) {
  const result = await apiDelete(`${GET_ALL_TEMPLATES}${payload.id}/`);
  return result;
}

export async function duplicateConfiguratorTemplate(payload) {
  const payloadToSend = new FormData();
  payloadToSend.append('configurator', payload.id);
  const result = await apiPost(`${DUPLICATE_TEMPLATES}`, payloadToSend, '', '', '', false);
  return result;
}

export const configuratorTemplateUpdateApi = createUpdateApiAction({
  actions: productConfiguratorsActions,
  endpointUrl: GET_ALL_TEMPLATES,
});

export async function getSceneViewsForPreview(sceneId) {
  const url = `${
    isV2() ? GET_CONFIGURATOR_VIEW_LIST_API_V2 : GET_CONFIGURATOR_VIEW_LIST_API
  }?scene=${sceneId}`;
  const result = await fetchAllPages((page) => {
    const paginatedUrl = `${url}&page=${page}`;
    return apiGet(paginatedUrl);
  });
  return result;
}

export async function getLabelOptionsData(labelId, page = 1) {
  const sceneId = selectSelectedSceneId(getAppState());
  const sortBy = selectConfiguratorSortBy(getAppState());
  let extraParams = {};
  if (sortBy !== DEFAULT_SORT_BY) {
    extraParams.sort = sortBy;
  }
  let url = `${
    isV2() ? GET_LABEL_OPTIONS_API_V2 : GET_LABEL_OPTIONS_API
  }?sceneoption=${labelId}&page=${page}${isV2() ? `&scene=${sceneId}` : ''}`;
  if (extraParams) {
    const keys = Object.keys(extraParams);
    keys.map((key) => {
      url += `&${key}=${extraParams[key]}`;
    });
  }
  const result = await apiGet(url);
  return result;
}

export async function getRenderStoreList(confId) {
  const url = `${GET_RENDER_STORE_LIST}?configurator_id=${confId}`;
  const result = await apiGet(url);
  return result;
}

export async function updateStoreListToConfigurator(id) {
  const url = `${GET_RENDER_STORE_LIST}${id}/`;
  const result = await apiPatch(url, undefined, null, null, null, false);
  return result;
}

export async function changeViewsOrder(dataPassed) {
  const payloadToSend = new FormData();
  await dataPassed.map((data) => {
    const keys = Object.keys(data);
    keys.map((key) => {
      payloadToSend.append(key.toString(), data[key]);
    });
  });
  const result = await apiPatch(
    `${isV2() ? REORDER_VIEWS_V2 : REORDER_VIEWS}`,
    payloadToSend,
    '',
    '',
    '',
    false
  );
  return result;
}

export const removeMainProductFromScene =
  ({ id }) =>
  (dispatch) => {
    const mockDataFetching = async () => {
      const updatedData = {
        main_product_id: '',
        sceneproduct: '',
        id: id,
      };
      const mainUrl = isV2() ? UPDATE_CONFIGURATOR_SCENE_API_V2 : UPDATE_CONFIGURATOR_SCENE_API;
      const url = mainUrl.replace(':sceneId', id);
      const result = await apiPatch(url, updatedData);
      if (result) {
        dispatch(configuratorActions.updateScene(result));
      }
      return result;
    };
    return mockDataFetching();
  };

export async function getPublicLink(modelId) {
  const result = await apiGet(`${CONFIG_PUBLIC_LINK_V2}?token=${modelId}`);
  return result;
}

export async function updatePublicLink({ token, isActive, email, store }) {
  const payloadToSend = new FormData();
  payloadToSend.append('is_active', isActive ? 'True' : 'False');
  if (email) {
    payloadToSend.append('email', email);
  }
  if (store?.length) {
    store.map((val) => payloadToSend.append('store', val));
  }
  const result = await apiPatch(
    `${CONFIG_PUBLIC_LINK_V2}?token=${token}`,
    payloadToSend,
    null,
    null,
    null,
    false
  );
  return result;
}

export async function getAllPublicData({ modelId, isOpenedFromAdminPanel, isRender = false }) {
  let url = CONFIG_PUBLIC_DATA_V3 + '?token=' + modelId;
  if (isOpenedFromAdminPanel) {
    url += `&is_render=${isRender}`;
  }
  const result = await fetchAllPages((page) => {
    const paginatedUrl = `${url}&page=${page}`;
    return apiGet(paginatedUrl);
  });
  return result;
}

export async function getAllPublicDataPrototype({ configuratorId, isRender }) {
  const url = `${CONFIG_PUBLIC_DATA_V3}${configuratorId}/?is_render=${isRender}`;
  const result = await fetchAllPages((page) => {
    const paginatedUrl = `${url}&page=${page}`;
    return apiGet(paginatedUrl);
  });
  return result;
}

export async function checkForUniCode(code) {
  const url = `/${CHECK_FOR_UNICODE}`;
  const result = await apiGet(`${url}`);
  return result;
}

export async function getLabelsDataInPrototype({
  token,
  storeId,
  v2 = false,
  sceneId,
  isPublic = false,
}) {
  const url = `${
    v2 ? GET_SCENE_LABEL_PUBLIC_API_V2 : GET_SCENE_LABEL_PUBLIC_API
  }?token=${token}&store_id=${storeId}&scene_id=${sceneId}&is_public=${isPublic}`;
  const result = await fetchAllPages((page) => {
    const paginatedUrl = `${url}&page=${page}`;
    return apiGet(paginatedUrl);
  });
  return result?.results || [];
}

export const getOptionsDataInPrototype =
  ({
    token,
    storeId,
    v2 = false,
    optionId,
    sceneId,
    isPublic = false,
    page = 1,
    extraParams = {},
  }) =>
  async (dispatch) => {
    let url = `${
      v2 ? GET_LABEL_OPTIONS_PUBLIC_API_V2 : GET_LABEL_OPTIONS_PUBLIC_API
    }?token=${token}&store_id=${storeId}&sceneoption_id=${optionId}&is_public=${isPublic}&page=${page}`;
    if (extraParams) {
      const keys = Object.keys(extraParams);
      keys.map((key) => {
        url += `&${key}=${extraParams[key]}`;
      });
    }
    const result = await apiGet(`${url}`);
    if (result?.next_link) {
      dispatch(
        configuratorLabelDetailsActions.setLabelNextPage({
          sceneId,
          labelId: optionId,
          nextPage: 2,
        })
      );
    } else {
      dispatch(
        configuratorLabelDetailsActions.setLabelNextPage({
          sceneId,
          labelId: optionId,
          nextPage: null,
        })
      );
    }
    return result || [];
  };

export const updateOptionsFromPrototype = ({ data, v2 = false }) => {
  const mockDataFetching = async () => {
    const result = await apiPatch(
      v2 ? UPDATE_LABEL_OPTIONS_API_V2 : UPDATE_LABEL_OPTIONS_API,
      JSON.stringify(data),
      'moveOptionsToLabel',
      null,
      null,
      false
    );
    return result;
  };
  return mockDataFetching();
};

export async function getTexturePreviewInPrototype({ storeId, textureId, v2 }) {
  const url = `${
    v2 ? GET_PROTOTYPE_PREVIEWS_API_V2 : GET_PROTOTYPE_PREVIEWS_API
  }?store=${storeId}&texture=${textureId}`;
  const result = await apiGet(`${url}`);
  return result?.results || [];
}

export async function updateTexturePreviewInPrototype({ id, payload, v2 }) {
  const url = `${v2 ? GET_PROTOTYPE_PREVIEWS_API_V2 : GET_PROTOTYPE_PREVIEWS_API}${id}/`;
  const result = await apiPatch(`${url}`, payload);
  return result || {};
}

export async function uploadDefaultThumbnail({ blobImage, fileName, presigned_data }) {
  const formData = new FormData();
  Object.entries(presigned_data.fields).forEach(([k, v]) => {
    formData.append(k, v);
  });
  formData.append('file', blobImage, fileName);
  return await axios.post(presigned_data.url, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export async function getLabelOptionsWithTime(storeId, labelId, page, is_render = false) {
  const url = `${
    isV2() ? GET_LABEL_OPTIONS_WITH_TIME_V2 : GET_LABEL_OPTIONS_WITH_TIME
  }?store_id=${storeId}&sceneoption=${labelId}&is_render=${is_render}&page=${page}&sort=-created_at`;
  const result = await apiGet(`${url}`);
  return result;
}

export const deletePreviewOnChangeTransformation = (data) => {
  return apiPostV2(isV2() ? DELETE_PREVIEWS_V2 : DELETE_PREVIEWS, { data }).send();
};

export const getScenesInPrototypeForPublic =
  ({ token, configuratorId, is_render = false, v2, page = 1 }) =>
  async (dispatch) => {
    const url = `${
      v2 ? GET_SCENE_PUBLIC_DATA_V2 : GET_SCENE_PUBLIC_DATA
    }?token=${token}&is_render=${is_render}&page=${page}`;
    const result = await apiGet(`${url}`);
    if (result?.next_link)
      dispatch(configuratorActions.setSceneNextPage({ configuratorId, nextPage: 2 }));
    return result;
  };

export const getScenesInPrototypeForPrivate =
  ({ configuratorId, is_render = false, v2, page = 1 }) =>
  async (dispatch) => {
    const url = `${
      v2 ? GET_SCENE_PRIVATE_DATA_V2 : GET_SCENE_PRIVATE_DATA
    }?configurator=${configuratorId}&is_render=${is_render}&page=${page}`;
    const result = await apiGet(`${url}`);
    if (result?.next_link)
      dispatch(configuratorActions.setSceneNextPage({ configuratorId, nextPage: 2 }));
    return result;
  };

export async function downloadImages({ renderId, v2 }) {
  const url = `${v2 ? DOWNLOAD_IMAGES_V2 : DOWNLOAD_IMAGES}${renderId}/`;
  const result = await apiGet(`${url}`);
  return result?.data;
}

export async function downloadShadowImages({ storeId, v2 }) {
  const url = `${v2 ? DOWNLOAD_SHADOW_IMAGES_V2 : DOWNLOAD_SHADOW_IMAGES}${storeId}/`;
  const result = await apiGet(`${url}`);
  return result?.data;
}

export async function uploadImages({ data, v2 }) {
  const result = await apiPostV2(v2 ? UPLOAD_IMAGES_V2 : UPLOAD_IMAGES, {
    data,
    isFormData: false,
  }).send();
  return result?.data;
}

export async function uploadShadowImages({ data, v2 }) {
  const result = await apiPostV2(v2 ? UPLOAD_SHADOW_IMAGES_V2 : UPLOAD_SHADOW_IMAGES, {
    data,
    isFormData: false,
  }).send();
  return result?.data;
}

export async function uploadHighResImagesToS3({ file, presigned_data }) {
  const formData = new FormData();
  Object.entries(presigned_data.fields).forEach(([k, v]) => {
    formData.append(k, v);
  });
  formData.append('file', file);
  return await axios.post(presigned_data.url, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export async function reRenderTexture(data) {
  const result = await apiPost(
    isV2() ? TEXTURE_RE_RENDER_V2 : TEXTURE_RE_RENDER,
    data,
    '',
    '',
    '',
    false
  );
  return result;
}

export const uploadAllThumbnailConfigurator = async (data, v2 = false) => {
  const result = await apiPost(
    isV2() || v2 ? UPLOAD_IMAGES_CONFIGURATOR_V2 : UPLOAD_IMAGES_CONFIGURATOR,
    data
  );
  return result?.data;
};

export const getShadowImages = async ({ sceneId, sceneview, v2 = false, isRender }) => {
  let url = `${
    v2 ? GET_SHADOW_IMAGES_V2 : GET_SHADOW_IMAGES
  }?scene=${sceneId}&is_render=${isRender}`;
  if (sceneview) {
    url = `${url}&sceneview=${sceneview}`;
  }
  const result = await fetchAllPages((page) => {
    const paginatedUrl = `${url}&page=${page}`;
    return apiGet(paginatedUrl);
  });
  return result?.results || [];
};

export const getShadowImagesPublic = async ({
  sceneId,
  sceneview,
  v2 = false,
  token,
  isRender,
}) => {
  let url = `${
    v2 ? GET_SHADOW_IMAGES_PUBLIC_V2 : GET_SHADOW_IMAGES_PUBLIC
  }?scene=${sceneId}&token=${token}&is_render=${isRender}`;
  if (sceneview) {
    url = `${url}&sceneview=${sceneview}`;
  }
  const result = await fetchAllPages((page) => {
    const paginatedUrl = `${url}&page=${page}`;
    return apiGet(paginatedUrl);
  });
  return result?.results || [];
};

export const getSceneViewsInPrototype = async ({ sceneId, v2 = false, store }) => {
  const url = `${
    v2 ? GET_SCENE_VIEWS_PROTOTYPE_V2 : GET_SCENE_VIEWS_PROTOTYPE
  }?scene=${sceneId}&store=${store}`;
  const result = await fetchAllPages((page) => {
    const paginatedUrl = `${url}&page=${page}`;
    return apiGet(paginatedUrl);
  });
  return result?.results || [];
};

export const getSceneViewsInPrototypePublic = async ({ sceneId, v2 = false, token, store }) => {
  const url = `${
    v2 ? GET_SCENE_VIEWS_PUBLIC_PROTOTYPE_V2 : GET_SCENE_VIEWS_PUBLIC_PROTOTYPE
  }?scene=${sceneId}&token=${token}&store=${store}`;
  const result = await fetchAllPages((page) => {
    const paginatedUrl = `${url}&page=${page}`;
    return apiGet(paginatedUrl);
  });
  return result?.results || [];
};

export const getAllContentTypeLighting = () => async (dispatch) => {
  const result = await apiGet(LIGHTING_CONTENT_LIST);
  if (result) {
    dispatch(configuratorActions.setAllContentType(result));
    return result || {};
  }
};

export async function addLightRoom(data) {
  const result = await apiPost(UPLOAD_MULTIPLE_LIGHTROOM, data, '', '', '', false);
  return result;
}

export const getCameraDataFromApi = (id, param) => async (dispatch) => {
  if (param) {
    const url = `${PRESET_CAMERA_ANGLE}?${param}=${id}`;
    const result = await apiGet(url);
    if (result?.results?.length) {
      return result?.results || [];
    }
  } else {
    return [];
  }
};

export const updateLightroom = (data, id) => async (dispatch) => {
  const url = `${GET_CONFIGURATOR_LIGHTING_API_V2}${id}/`;
  const updatedData = await apiPatch(url, data, '', '', '', false);
  return updatedData;
};

export const updateShadowOpacityInView = async ({ data, v2 }) => {
  const mainUrl = v2 ? UPDATE_CONFIGURATOR_VIEW_API_V2 : UPDATE_CONFIGURATOR_VIEW_API;
  const url = mainUrl.replace(':viewId', data.id);
  const updatedData = await apiPatch(url, data);
  return updatedData;
};

export const getSceneIds = async ({ configuratorId, isV2 = false }) => {
  const url = `${GET_SCENE_IDS_V2}?config_id=${configuratorId}`;
  const result = await fetchAllPages((page) => {
    const paginatedUrl = `${url}&page=${page}`;
    return apiGet(paginatedUrl);
  });
  return result?.results || [];
};

export const getDefaultTextures = async ({ sceneId, labelId }) => {
  sceneId = sceneId || selectSelectedSceneId(getAppState());
  const url = `${
    isV2() ? GET_DEFAULT_TEXTURES_V2 : GET_DEFAULT_TEXTURES
  }?scene=${sceneId}&sceneoption=${labelId}`;
  const result = await fetchAllPages((page) => {
    const paginatedUrl = `${url}&page=${page}`;
    return apiGet(paginatedUrl);
  });
  return result?.results || [];
};

export const getSelectedTextures = async ({ sceneId, labelId }) => {
  sceneId = sceneId || selectSelectedSceneId(getAppState());
  const url = `${
    isV2() ? GET_SELECTED_TEXTURES_V2 : GET_SELECTED_TEXTURES
  }?scene=${sceneId}&sceneoption=${labelId}`;
  const result = await fetchAllPages((page) => {
    const paginatedUrl = `${url}&page=${page}`;
    return apiGet(paginatedUrl);
  });
  return result?.results || [];
};

export const setSceneTextureSequence = async (data) => {
  const result = await apiPost(SET_SCENE_TEXTURE_SEQUENCE, data, '', '', '');
  return result;
};

export const getAllSceneToken = async ({ id, sceneLinkType = 'SCENE', v2 }) => {
  const configuratorId = id || selectConfiguratorId(getAppState());
  const url = `${isV2() || v2 ? GET_ALL_SCENE_TOKEN_V2 : GET_ALL_SCENE_TOKEN}`;
  const result = await fetchAllPages((page) => {
    const paginatedUrl = `${url}?configurator=${configuratorId}&scenelinktype=${sceneLinkType}&page=${page}`;
    return apiGet(paginatedUrl);
  });
  return result?.results || [];
};

export const updateAllSceneToken = async ({ id, sceneLinkType = 'SCENE', token, data, v2 }) => {
  const configuratorId = id || selectConfiguratorId(getAppState());
  const url = `${isV2() || v2 ? GET_ALL_SCENE_TOKEN_V2 : GET_ALL_SCENE_TOKEN}`;
  const updatedData = {
    ...data,
    scenelinktype: sceneLinkType,
    token,
    configurator: configuratorId,
  };
  const response = await apiPatch(url, updatedData);
  return response;
};

export const createAllSceneToken = async ({ id, data, v2 }) => {
  const configuratorId = id || selectConfiguratorId(getAppState());
  const url = `${isV2() || v2 ? GET_ALL_SCENE_TOKEN_V2 : GET_ALL_SCENE_TOKEN}`;
  const updatedData = { ...data, scenelinktype: 'COMBINATION', configurator: configuratorId };
  const formData = objectToFormData(updatedData, { separateArrayItems: true });
  const response = await apiPost(url, formData, null, null, null, false);
  return response;
};

export const searchTextureInLabel = async ({
  v2 = false,
  token,
  optionId,
  storeId,
  isPublic,
  textureName = '',
}) => {
  const url = `${
    v2 ? GET_LABEL_OPTIONS_PUBLIC_API_V2 : GET_LABEL_OPTIONS_PUBLIC_API
  }?token=${token}&store_id=${storeId}&sceneoption_id=${optionId}&is_public=${isPublic}&search=${textureName}`;
  const response = await apiGet(`${url}`);
  return response?.results || [];
};

export const getAllMergeImages = async ({ v2 = false, token, payload }) => {
  const formData = objectToFormData(payload, { separateArrayItems: true });
  const url = `${v2 ? GET_CONFIGURATOR_ALL_MERGE_V2 : GET_CONFIGURATOR_ALL_MERGE}?token=${token}`;
  const response = await apiPost(url, formData);
  return response;
};

export const getSingleMergeImage = async ({ v2 = false, token, payload }) => {
  const formData = objectToFormData(payload, { separateArrayItems: true });
  const url = `${
    v2 ? GET_CONFIGURATOR_SINGLE_MERGE_V2 : GET_CONFIGURATOR_SINGLE_MERGE
  }?token=${token}`;
  const response = await apiPost(url, formData);
  return response;
};

export const renderStoreUpdate = async () => {
  const configuratorId = selectConfiguratorId(getAppState());
  const response = await apiPost(RENDER_STORE_KEYS_UPDATE_V2, {
    configurator: configuratorId,
  });
  return response;
};

export const getPublicProductData = async (sceneId) => {
  const url = GET_PUBLIC_PRODUCT_DATA + '?scene=' + sceneId;
  const result = await fetchAllPages((page) => {
    const paginatedUrl = `${url}&page=${page}`;
    return apiGet(paginatedUrl);
  });
  return result?.results || [];
};

export function createTextureLinkingApi({ sceneId, configuratorId }) {
  return apiPostV2(UPDATE_TEXTURE_LINKING, {
    data: {
      scene: sceneId,
      configurator: configuratorId,
      scene_texture_linking_json_name: 'scene_texture_linking_json.json',
    },
  }).send();
}

export function updateTextureLinkingApi({ sceneId, configuratorId, id }) {
  return apiPatch(`${UPDATE_TEXTURE_LINKING}${id}/`, {
    scene: sceneId,
    configurator: configuratorId,
    scene_texture_linking_json_name: 'scene_texture_linking_json.json',
  });
}

export async function getTextureLinkingApi({ token, configuratorId, sceneId, isPublic = false }) {
  let url = `${
    isPublic ? GET_TEXTURE_LINKING_PUBLIC : GET_TEXTURE_LINKING
  }?configurator_id=${configuratorId}&scene_id=${sceneId}`;
  if (isPublic) {
    url = `${url}&token=${token}`;
  }
  const result = await fetchAllPages((page) => {
    const paginatedUrl = `${url}&page=${page}`;
    return apiGet(paginatedUrl);
  });
  return result?.results || [];
}

export function deleteTextureLinkingApi({ id }) {
  return apiDelete(`${UPDATE_TEXTURE_LINKING}${id}/`);
}